import menu from '@/api/menu'
import role from '@/api/role'
export default {
  data() {
    return {
      dataSource: [{}],
      length: [
        {
          selectAll: false,
          select: ''
        }
      ],
      authorityIds: []
    }
  },
  watch: {
    //监听相同路由下参数变化的时候，从而实现异步刷新
    $route: {
      handler() {
        this.id = this.$route.params.id
        this.getMenus()
      },
      immediate: true
    }
  },
  methods: {
    async getMenus() {
      this.$set(this.dataSource, 0, await menu.get())
      this.authorityIds = await role.getAuthority(this.id)
      this.checkSelectAll(0)
    },
    openChildren(index, val) {
      if (
        this.dataSource[index][val].children &&
        this.dataSource[index][val].children.length
      ) {
        this.$set(this.length, index, {
          selectAll: this.length[index].selectAll,
          select: val
        })
        this.$set(this.length, index + 1, {
          selectAll: false,
          select: ''
        })
        this.$set(
          this.dataSource,
          index + 1,
          this.dataSource[index][val].children
        )
        this.length.splice(index + 2)
      }
      this.checkSelectAll(index + 1)
    },
    changeAuthority(id, i) {
      const index = this.authorityIds.indexOf(id)
      if (index > -1) {
        this.authorityIds.splice(index, 1)
      } else {
        this.authorityIds.push(id)
      }
      this.checkSelectAll(i)
    },
    changeSelectAll(index, val) {
      this.length[index].selectAll = val
      if (val) {
        this.dataSource[index].forEach(item => {
          if (!this.authorityIds.includes(item.authorityId)) {
            this.authorityIds.push(item.authorityId)
          }
        })
      } else {
        this.dataSource[index].forEach(item => {
          const index = this.authorityIds.indexOf(item.authorityId)
          if (index > -1) {
            this.authorityIds.splice(index, 1)
          }
        })
      }
    },
    checkSelectAll(index) {
      if (!this.dataSource[index]) {
        return
      }
      const flag = this.dataSource[index].some(item => {
        if (!this.authorityIds.includes(item.authorityId)) {
          return true
        }
      })
      this.length[index].selectAll = !flag
    },
    async save() {
      await role.setAuthority(this.id, this.authorityIds)
      this.$message.success({
        title: 'Success',
        content: 'Changes for Authority has updated Successfully!'
      })
    },
    reset() {
      this.getMenus()
      // this.getAuthority()
    }
  }
}
